function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { InfoIcon } from '@domain-group/fe-co-icon';
import { Card, Button } from '@domain-group/fe-co-allhomes-design-system';
import { WhatIsBTRModal } from './what-is-btr-modal';
import * as styles from './btr-info-message.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MessagesBold = {
  listing: 'This is a Build-to-Rent property.',
  'search-result': 'Your search includes Build-to-Rent properties.'
};
var MessagesText = {
  listing: 'These properties may offer a more stable lease and different amenities compared to other rentals.',
  'search-result': 'These may offer a more stable lease and different amenities compared to other rentals.'
};
var BtrInfoMessage = _ref => {
  var variant = _ref.variant;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(WhatIsBTRModal, {
    isOpen: isModalOpen,
    onClose: () => setIsModalOpen(false)
  }), ___EmotionJSX(Card, {
    css: styles.btrInfoMessageCard
  }, ___EmotionJSX("div", {
    css: styles.btrInfoMessageCardContent
  }, ___EmotionJSX("div", null, ___EmotionJSX(InfoIcon, {
    css: styles.btrInfoMessageIcon
  })), ___EmotionJSX("div", null, ___EmotionJSX("span", {
    css: styles.btrInfoMessageBold
  }, MessagesBold[variant], ' '), ___EmotionJSX("span", null, MessagesText[variant], " "), ___EmotionJSX(Button, {
    appearance: "ghostNeutral",
    css: styles.btrInfoMessageFindOutMoreButton,
    onClick: () => {
      setIsModalOpen(true);
    }
  }, "Find out more")))));
};
export { BtrInfoMessage };